import React from "react";
import classNames from "classnames";
import { useHistory, Link } from "react-router-dom";
import Swal from "sweetalert2";

import BalanceWithdrawButton from "../BalanceWithdrawButton/BalanceWithdrawButton";

import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container,
  Modal,
  NavbarToggler,
  ModalHeader,
  Popover,
  PopoverBody
} from "reactstrap";

// hooks
import useUpdateBalance from "../../hooks/useUpdateBalance";
import useFetchUserMe from "../../hooks/useFetchUserMe";
import useFetchTransactions from "../../hooks/useFetchTransactions";

// logo
import logoGreen from "assets/img/automaproa.PNG";

function AdminNavbar(props) {
  const [collapseOpen, setcollapseOpen] = React.useState(false);
  const [modalSearch, setmodalSearch] = React.useState(false);
  const [color, setcolor] = React.useState("navbar-transparent");
  const history = useHistory();

  // popover para "copiado"
  const [popoverOpen, setPopoverOpen] = React.useState(false);
  const togglePopover = () => setPopoverOpen(!popoverOpen);

  const userId = localStorage.getItem("userId");

  // Dados do usuário
  const { data: userMe, error, loading, refetch } = useFetchUserMe();

  // Total de saques (página 1 já ajuda a dar contexto; ajuste se quiser todas as páginas)
  const {
    data: withdrawsData,
    error: withdrawsError,
    loading: withdrawsLoading,
  } = useFetchTransactions(1, "Withdraw");

  const totalWithdrawsCents = withdrawsData?.data
    ? withdrawsData.data.reduce((sum, t) => sum + Number(t.amount || 0), 0)
    : 0;

  const formatBRL = (cents) =>
    (Number(cents || 0) / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    });

  const formatDate = (iso) => {
    if (!iso) return "—";
    // aceita "YYYY-MM-DD" ou ISO completo
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    return d.toLocaleDateString("pt-BR");
  };

  const maskCPF = (cpf) => {
    if (!cpf) return "—";
    const s = String(cpf).replace(/\D/g, "");
    if (s.length !== 11) return cpf;
    return `${s.slice(0,3)}.${s.slice(3,6)}.${s.slice(6,9)}-${s.slice(9)}`;
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setPopoverOpen(true);
      setTimeout(() => setPopoverOpen(false), 1200);
    } catch {}
  };

  const callbackUpdateBalance = () => {
    refetch(); // atualiza dados após mexer no saldo
  };

  const { openUpdateBalanceModal, ModalComponent } = useUpdateBalance(
    userId,
    callbackUpdateBalance
  );

  React.useEffect(() => {
    if (error) {
      Swal.fire({
        icon: "error",
        title: "Erro ao carregar informações do usuário",
        text: typeof error === "string" ? error : "Tente novamente."
      }).then(() => {
        localStorage.clear();
        history.push("/auth/login");
      });
    }
  }, [error, history]);

  React.useEffect(() => {
    window.addEventListener("resize", updateColor);
    return () => window.removeEventListener("resize", updateColor);
  });

  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setcolor("bg-dark");
    } else {
      setcolor("navbar-transparent");
    }
  };

  const toggleCollapse = () => {
    setcolor(collapseOpen ? "navbar-transparent" : "bg-dark");
    setcollapseOpen(!collapseOpen);
  };

  const toggleModalSearch = () => setmodalSearch(!modalSearch);

  const logout = () => {
    localStorage.clear();
    history.push("/auth/login");
  };

  // Loading simples do topo (mantido)
  if (loading) {
    return (
      <Navbar className={classNames("navbar-absolute d-flex p-0 m-0", color)}>
        <Container fluid>
          <p>Carregando...</p>
        </Container>
      </Navbar>
    );
  }

  // infos do usuário
  const nome = userMe?.name || "Usuário";
  const nascimento = userMe?.birthday ? userMe?.birthday : "—";
  const cpf = userMe?.document?.number || "";
  // saldo já vem calculado (balance + credit) do hook useFetchUserMe e salvo no localStorage/balance
  // userMe.balance no hook agora é "wallet.balance" original.
  // Porém, o hook useFetchUserMe retorna o objeto completo da API em `data` (userMe).
  // E lá eu calculei o total e salvei no localStorage("balance").
  // O hook retorna `data` = response.data (que tem wallet.balance e wallet.credit).
  // Se eu quiser exibir o total aqui, preciso somar novamente ou usar o localStorage.
  
  // Ajuste: usar o cálculo local aqui também para consistência visual imediata
  const wallet = userMe?.wallet || {};
  const rawBalance = Number(wallet.balance || 0);
  const rawCredit = Number(wallet.credit || 0);
  const totalBalanceCents = rawBalance + rawCredit; // soma em centavos
  const saldo = formatBRL(totalBalanceCents);

  const totalSaques = formatBRL(totalWithdrawsCents);

  // (Opcional) status KYC / conta
  const kycOk = Number(userMe?.kyc_verification) === 1 || userMe?.identity_verify === 1;
  const statusConta = localStorage.getItem("subscription_status") === "active" ? "Ativo" : "Inativo";

  return (
    <>
      <Navbar
        className={classNames("navbar-absolute d-flex p-0 m-0", color)}
        expand="lg"
      >
        <Container
          fluid
          style={{
            display: "flex",
            alignItems: "flex-end",
            flexDirection: "row",
            flexWrap: "nowrap"
          }}
        >
          {/* Toggle + logo */}
          <div className="navbar-wrapper">
            <div
              className={classNames("navbar-toggle d-inline", {
                toggled: props.sidebarOpened
              })}
            >
              <NavbarToggler onClick={props.toggleSidebar}>
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </NavbarToggler>
            </div>
            <NavbarBrand href="#pablo" onClick={e => e.preventDefault()}>
              <img
                className={window.innerWidth <= 450 ? "d-none" : "d-block"}
                src={logoGreen}
                alt="react-logo"
                width={50}
              />
            </NavbarBrand>
          </div>

          {/* Saldo / Saque Rápido */}
          <div className="d-flex nav-balance mt-2 mt-lg-0 mt-xl-0">
            <BalanceWithdrawButton
              onUpdate={callbackUpdateBalance}
              balance={totalBalanceCents / 100}
            />
          </div>

          {/* Hamburguer collapse */}
          <NavbarToggler onClick={toggleCollapse}>
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </NavbarToggler>

          {/* Right side */}
          <Collapse navbar isOpen={collapseOpen}>
            <Nav className="ml-auto position-relative" navbar>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle caret color="default" nav onClick={(e) => e.preventDefault()}>
                  <div className="photo">
                    <img alt="..." src={require("assets/img/anime3.png")} />
                  </div>
                  <b className="caret d-none d-lg-block d-xl-block" />
                  <p className="d-lg-none">Menu</p>
                </DropdownToggle>

                {/* MENU RICO EM INFO */}
                <DropdownMenu className="dropdown-navbar bg-dark dropdown-menu-right" right tag="ul" style={{ minWidth: 320 }}>
                  {/* Header com nome + resumo */}
                  <li className="px-3 pt-3 pb-2" style={{ borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
                    <div className="d-flex align-items-center">
                      <img
                        src={require("assets/img/anime3.png")}
                        alt="avatar"
                        width={42}
                        height={42}
                        className="rounded-circle mr-2"
                      />
                      <div>
                        <div style={{ fontWeight: 700 }}>{nome}</div>
                        <div style={{ fontSize: 12, opacity: 0.8 }}>
                          Status:
                          • <strong style={{color: localStorage.getItem("subscription_status") === "active" ? "lightgreen" : "red"}}>{statusConta}</strong>
                        </div>
                      </div>
                    </div>
                  </li>

                  {/* Linhas de detalhes */}
                  <li className="px-3 py-2 d-flex justify-content-between">
                    <span className="text-muted">Nascimento</span>
                    <strong>{nascimento}</strong>
                  </li>

                  <li className="px-3 py-2 d-flex justify-content-between align-items-center">
                    <span className="text-muted">CPF</span>
                    <div className="d-flex align-items-center">
                      <strong id="cpfCopyTarget">{maskCPF(cpf)}</strong>
                      {cpf && (
                        <>
                          <Button
                            id="cpfCopyBtn"
                            size="sm"
                            className="ml-2"
                            color="secondary"
                            outline
                            onClick={() => copyToClipboard(cpf)}
                          >
                            Copiar
                          </Button>
                          <Popover
                            placement="top"
                            isOpen={popoverOpen}
                            target="cpfCopyBtn"
                            toggle={togglePopover}
                          >
                            <PopoverBody>Copiado!</PopoverBody>
                          </Popover>
                        </>
                      )}
                    </div>
                  </li>

                  <li className="px-3 py-2 d-flex justify-content-between">
                    <span className="text-muted">Saldo</span>
                    <strong>{saldo}</strong>
                  </li>

                  <li className="px-3 py-2 d-flex justify-content-between" style={{ borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
                    <span className="text-muted">Total em Saques</span>
                    <strong>
                      {withdrawsLoading ? "Carregando..." : withdrawsError ? "—" : totalSaques}
                    </strong>
                  </li>

                  {/* Ações rápidas */}
                  <NavLink tag="li" className="px-3 pt-2">
                    <DropdownItem className="nav-item p-0">
                      <Link to="/deposit" className="btn btn-primary btn-block btn-sm">
                        Depositar
                      </Link>
                    </DropdownItem>
                  </NavLink>

                  <NavLink tag="li" className="px-3 pb-2">
                    <DropdownItem className="nav-item p-0">
                      <Button color="danger" className="btn-block btn-sm" onClick={logout}>
                        Sair
                      </Button>
                    </DropdownItem>
                  </NavLink>
                </DropdownMenu>
              </UncontrolledDropdown>

              <li className="separator d-lg-none" />
            </Nav>
          </Collapse>
        </Container>
      </Navbar>

      {/* Busca */}
      <Modal modalClassName="modal-search" isOpen={modalSearch} toggle={toggleModalSearch}>
        <ModalHeader>
          <Input placeholder="SEARCH" type="text" />
          <button aria-label="Close" className="close" onClick={toggleModalSearch}>
            <i className="tim-icons icon-simple-remove" />
          </button>
        </ModalHeader>
      </Modal>

      {/* Modal do Hook (atualizar saldo, etc.) */}
      <ModalComponent />
    </>
  );
}

export default AdminNavbar;
